import { NgModule } from '@angular/core';
import { ReactiveInputDirective } from './reactive-input.directive';


@NgModule({
    declarations: [
        ReactiveInputDirective,
    ],
    exports: [
        ReactiveInputDirective,
    ],
})
export class ReactiveInputModule { }